module.exports = __webpack_public_path__ + "img/ic_muscle@3x.dd3f66a3.png";